import { DevQueryClientProvider } from 'providers/osQueryClient/DevQueryClientProvider'
import { ProdQueryClientProvider } from 'providers/osQueryClient/ProdQueryClientProvider'

export const OsQueryClientProvider = process.env.DEV ? DevQueryClientProvider : ProdQueryClientProvider
